/*
 * type of assessment measurement configuration
 */
import { z } from 'zod';
export const assessmentMeasurementConfigurationTagSchema = z.object({
    type: z.enum(['location', 'sampleType', 'conditionality', 'custom', 'objectiveGroupType']),
    text: z.string(),
});
//# sourceMappingURL=assessment-measurement-configuration-tag.js.map